import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Google OAuth 回调页面（在 popup 弹窗中打开）
 * 仅负责从 URL hash 中提取 id_token，通过 postMessage 传递给主窗口，然后关闭自身
 */
export default React.memo(function GoogleCallback() {
  const { t } = useTranslation()

  useEffect(() => {
    const hash = window.location.hash.substring(1)
    const params = new URLSearchParams(hash)
    const idToken = params.get('id_token')
    const error = params.get('error')

    if (window.opener) {
      // 在 popup 中：将结果发送给父窗口
      window.opener.postMessage(
        {
          type: 'GOOGLE_LOGIN_CALLBACK',
          idToken: idToken || null,
          error: error || null,
        },
        window.location.origin
      )
      // 关闭弹窗
      window.close()
    } else {
      // 兜底：如果不是 popup（如用户直接访问），重定向到登录页
      window.location.href = '/login'
    }
  }, [])

  return (
    <div className="bg-white h-full flex items-center justify-center">
      <p className="text-gray-500 text-sm">{t('正在处理中...')}</p>
    </div>
  )
})
